import { useSyncExternalStore } from 'react';

// App-wide registry of long-running work, rendered by <BackgroundJobs />.
// Lives outside React so services and pages share it, and jobs survive navigation.
let jobs = [];
let nextId = 0;
const listeners = new Set();
const emit = () => listeners.forEach((listener) => listener());

// Jobs that finish faster than this never appear, so quick calls don't flash the indicator.
const SHOW_AFTER_MS = 400;

export function startJob(label) {
  const id = ++nextId;
  jobs = [...jobs, { id, label, done: null, total: null, visible: false }];
  const reveal = setTimeout(() => {
    jobs = jobs.map((job) => (job.id === id ? { ...job, visible: true } : job));
    emit();
  }, SHOW_AFTER_MS);
  return {
    // patch: { label?, done?, total? }
    update(patch) {
      jobs = jobs.map((job) => (job.id === id ? { ...job, ...patch } : job));
      emit();
    },
    finish() {
      clearTimeout(reveal);
      jobs = jobs.filter((job) => job.id !== id);
      emit();
    },
  };
}

export async function runJob(label, work) {
  const job = startJob(label);
  try {
    return await work(job);
  } finally {
    job.finish();
  }
}

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export function useBackgroundJobs() {
  return useSyncExternalStore(subscribe, () => jobs);
}
